import { FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { CommonIP, FileWithProgress, IP } from '@model/ftf-api.model';
import { SelectionFormArray } from '@utils/selection-form-array';

export interface UploadTableFormControl {
  id: FormControl<string>;
  identifier: FormControl<string>;
  ipType: FormControl<IP.TypeEnum>;
  files: SelectionFormArray<FormGroup>;
  includeFiles: FormControl<boolean>;
}

export interface UploadTableFormData {
  id: string;
  identifier: string;
  ipType: IP.TypeEnum;
  files: FileWithProgress[];
  includeFiles: boolean;
}

export interface TableEvent {
  identifier: string;
  ipType: IP.TypeEnum;
  form: FormGroup<UploadTableFormControl>;
}

export interface TrifoldItemEvent {
  item: CommonIP;
}

export const maxByteLength = (maxLength: number) => {
  return (control: FormControl): ValidationErrors | null => {
    const getByteLength = (str: string): number => new Blob([str]).size;
    const isValid = control.value == null || getByteLength(control.value) <= maxLength;
    return isValid ? null : { invalidByteLength: true };
  };
};

export const validateExtension = (ext: string) => {
  return (control: FormControl): ValidationErrors | null => {
    const isValid = control.value !== null && control.value.endsWith(`.${ext}`);
    return isValid ? null : { extensionMismatch: ext };
  };
};
